/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/819/interface/api/cat_12627
 */

import { message } from 'ant-design-vue'
import {
  abtest_list_post,
  abtest_modifystatus_post,
  abtest_query_get,
  abtest_save_post,
  abtest_queryLog_get,
  abtest_remove_get,
  abtest_getAbReportBaseInfo_get,
  abtest_getAbReportInfo_post,
  abtest_listAbtestMetricOption_get,
  abtest_listAbtestModule_get
} from 'server/modules/12627'

// 分页查询列表
export const abtest_list_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 修改状态
export const abtest_modifystatus_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_modifystatus_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据id查询详情
export const abtest_query_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_query_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存
export const abtest_save_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_save_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询操作日志
export const abtest_queryLog_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_queryLog_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除
export const abtest_remove_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_remove_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询实验报告基本数据
export const abtest_getAbReportBaseInfo_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_getAbReportBaseInfo_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询实验报告报表数据
export const abtest_getAbReportInfo_post_ = async function(params) {
  const { success, data, retInfo } = await abtest_getAbReportInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询AB测试指标选项
export const abtest_listAbtestMetricOption_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_listAbtestMetricOption_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询实验模块选项
export const abtest_listAbtestModule_get_ = async function(params) {
  const { success, data, retInfo } = await abtest_listAbtestModule_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
